import React, { Suspense } from "react";
import { Helmet } from "react-helmet";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import { Result, Spin } from "antd";

import { RateCardProvider } from "components/ratecard/contextProviders";
import ServicePage from "pages/_common/organization/OrganizationRateCardIndexPage/ServicePage";

// Lazy load sub pages
// const BillingFrequencyPage = lazy(
//   () => import("pages/_common/organization/OrganizationRateCardIndexPage/BillingFrequencyPage")
// );

const OrganizationRateCardRouter = () => {
  const { path } = useRouteMatch();

  return (
    <Suspense fallback={<Spin />}>
      <Helmet title="Sierra - Organization's Rate Card" />
      <Switch>
        <Route exact path={path}>
          {/* <BillingFrequencyPage /> */}
        </Route>
        <Route path={`${path}/:service_id`}>
          <RateCardProvider>
            <ServicePage />
          </RateCardProvider>
        </Route>
        <Route path="*">
          <Result status="404" title="404" subTitle="Sorry, the page you visited does not exist." />
        </Route>
      </Switch>
    </Suspense>
  );
};

export default OrganizationRateCardRouter;
